import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import dayjs from 'dayjs';
import logo from '../../../livezone_logo.png?inline';
import './NotStartedEventMap.scss';
const NotStartedEventMap = (props) => {
    const { event } = props;
    return (_jsxs("div", { className: "upcoming-shell", children: [_jsx("img", { className: "upcoming-logo", src: logo, alt: "LiveZone" }), _jsx(MapContainer, { center: event.location, zoom: event.zoom, style: {
                    width: '100%',
                    zIndex: '0',
                    cursor: 'default'
                }, maxZoom: 22, children: _jsx(TileLayer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }) }), _jsxs("div", { className: "jumbotron", children: [_jsx("h1", { children: event.name }), _jsx("p", { className: "lead", children: "The GPS will be available after:" }), _jsx("h2", { children: dayjs(event.publicDate).format('YYYY-MM-DD HH:mm') }), _jsx("hr", { className: "my-4" })] })] }));
};
export default NotStartedEventMap;
